module.exports = __webpack_public_path__ + "media/derect_tutorial_voor_de_klas.4f918fcd.mp4";